import type { DomainManifest } from 'modules/core/lib/manifests/types'
import type { Navigation, NavigationPaths } from 'modules/core/lib/navigation/context'

import { CreateTrainingRequestActivity } from 'modules/trainings/activities/CreateTrainingRequest'
import { CreateTrainingRequestFromCatalogActivity } from 'modules/trainings/activities/CreateTrainingRequestFromCatalog'
import { DeleteSurveyActivity } from 'modules/trainings/activities/DeleteSurvey'
import { EditSurveySettingsActivity } from 'modules/trainings/activities/EditSurveySettings'
import { MyTrainingRequestActivity } from 'modules/trainings/activities/MyTrainingRequest'
import { SendSurveyActivity } from 'modules/trainings/activities/SendSurvey'
import { TrainingRequestActivity } from 'modules/trainings/activities/TrainingRequest'

export const manifest = {
  sidebar: (_navigation: Navigation<NavigationPaths>) => ({
    items: [],
  }),
  activities: {
    createTrainingRequest: {
      component: CreateTrainingRequestActivity,
    },
    createTrainingRequestFromCatalog: {
      component: CreateTrainingRequestFromCatalogActivity,
    },
    sendSurvey: {
      component: SendSurveyActivity,
    },
    deleteSurvey: {
      component: DeleteSurveyActivity,
    },
    editSurveySettings: {
      component: EditSurveySettingsActivity,
    },
    trainingRequest: {
      component: TrainingRequestActivity,
    },
    myTrainingRequest: {
      component: MyTrainingRequestActivity,
    },
  },
} as const satisfies DomainManifest
